<template>
    <ul class="statistics d-flex justify-content-between">
        <li class="panel stats narrow mr-2">
            <h6>Check-ins</h6>

            <div class="d-flex">
                <h1 class="mr-2">{{ reservation.paxCheckedIn }}/{{ paxTotal }}</h1>

                <ul class="ml-5">
                    <li class="color-6">{{ missing }} missing</li>
                    <li>{{ reservation.paxNoShow }} no show</li>
                </ul>
            </div>
        </li>

        <li class="panel stats narrow flex-all mr-2">
            <h6>Extras</h6>

            <ul v-if="extras.length > 0">
                <li v-for="extra in extras">
                    <div v-if="extra.item.quantity">
                        {{ extra.item.quantity }} {{ extra.item.name }}
                    </div>
                </li>
            </ul>
            <div v-else>-</div>
        </li>

        <li class="panel stats mixed narrow d-flex">
            <div class="separator mr-3">
                <h6>Total</h6>
                <h1>{{ paid.toFixed(2) }}&euro;</h1>
            </div>
            <div>
                <h6>In due</h6>
                <h1>
                    <span v-if="due > 0" class="color-6">
                        {{ due.toFixed(2) }}&euro;
                    </span>
                    <span v-else>-</span>
                </h1>
            </div>
        </li>
    </ul>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    export default {
        mixins: [reservationsMixin],
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
            reservation: function() {
                return this.getClonedReservation;
            },
            extras: function() {
                console.log(this.reservation.event.product.extras.filter(e => e.item.quantity > 0));

                return this.reservation.event.product.extras.filter(e => e.item.quantity > 0);
            },
            missing: function() {
                return this.reservation.paxTotal - this.reservation.paxCheckedIn;
            },
        }
    }
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables.scss';

    .statistics {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1;
        background-color: $lighter;
        border-top: 1px solid $light;
        padding: 0.75rem;
    }
</style>



// WEBPACK FOOTER //
// ViewStatistics.vue?3f238b36